import { render, staticRenderFns } from "./SAccProjectJira.vue?vue&type=template&id=539ad424&scoped=true"
import script from "./SAccProjectJira.vue?vue&type=script&lang=ts"
export * from "./SAccProjectJira.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539ad424",
  null
  
)

export default component.exports